import { Modal } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import AddBtn from "../common/AddBtn";
import AddServiceLocation from "./AddServiceLocation";

const TopHeading = ({ total, refetch }: any): ReactElement => {
  const [visible, setVisible] = useState<boolean>(undefined);

  const onClose = () => {
    refetch();
    setVisible(!visible);
  };

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row d-flex-sb mb-15">
          <div className="col-lg-6 col-md-6 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l wrap d-flex-nowrap d-flex-base">
                Service Location List{" "}
                <span className="d-flex-l ml-1">{total || 0} Location(s)</span>
              </h2>
            </div>
          </div>

          <div className="single-button">
            <AddBtn onClick={() => setVisible(true)} />
          </div>

          <Modal
            title="Add Location"
            visible={!!visible}
            onCancel={onClose}
            okText={`Submit`}
            footer={false}
          >
            <AddServiceLocation onCloseMethod={onClose} />
          </Modal>
        </div>
      </div>
    </div>
  );
};

TopHeading.propTypes = {
  Id: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  title: PropTypes.string,
};

export default TopHeading;
